import { tns } from 'tiny-slider/src/tiny-slider';

class TeamSlider {
    constructor(el, prevBtn, nextBtn, navContainer = null) {
        this.el = el;
        this.prevBtn = prevBtn;
        this.nextBtn = nextBtn;
        this.nav = navContainer;
        this.initSlider();
    }

    initSlider() {
        const slider = tns({
            container: this.el,
            items: 1,
            autoplay: false,
            controls: false,
            nav: !!this.nav,
            navContainer: this.nav || false,
            mouseDrag: true,
            swipeAngle: false,
            preventScrollOnTouch: 'auto',
            speed: 400
        });

        if (this.prevBtn) {
            this.prevBtn.addEventListener("click", () => slider.goTo("prev"));
        }
        if (this.nextBtn) {
            this.nextBtn.addEventListener("click", () => slider.goTo("next"));
        }

        return slider;
    }
}

export default TeamSlider;
